const DOCUMENT_ROUTE = /^\/documents\/([^/]+)\/?$/;

/** The signed-in document browser is the product's main application entry. */
export const DOCUMENT_LIBRARY_PATH = '/documents';
export const LOCAL_TEMPLATE_HANDOFF_KEY = 'kilncat.local-template.v1';

/** Clean editor URL. The document id is also the collaboration room id. */
export function editorDocumentPath(id: string): string {
  return `/documents/${encodeURIComponent(id)}`;
}

/** Resolve the high-entropy public credential from a URL fragment. */
export function shareTokenFromHash(hash = window.location.hash): string | null {
  if (!hash.startsWith('#share=')) return null;
  try {
    const token = decodeURIComponent(hash.slice('#share='.length));
    return token && /^[A-Za-z0-9_-]+$/.test(token) ? token : null;
  } catch {
    return null;
  }
}

/** Resolve a routed cloud document, rejecting malformed or nested paths. */
export function documentIdFromPath(pathname = window.location.pathname): string | null {
  const match = DOCUMENT_ROUTE.exec(pathname);
  if (!match) return null;
  try {
    const id = decodeURIComponent(match[1]);
    return /^[A-Za-z0-9-]+$/.test(id) ? id : null;
  } catch {
    return null;
  }
}
